import { render, staticRenderFns } from "./CarrouselCourseMarketplace.vue?vue&type=template&id=0437f96a&scoped=true"
import script from "./CarrouselCourseMarketplace.vue?vue&type=script&lang=js"
export * from "./CarrouselCourseMarketplace.vue?vue&type=script&lang=js"
import style0 from "./CarrouselCourseMarketplace.vue?vue&type=style&index=0&id=0437f96a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0437f96a",
  null
  
)

export default component.exports